var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.64333 13.5351L10 11.1784L12.3567 13.5351L13.535 12.3568L11.1783 10.0001L13.535 7.64342L12.3567 6.46509L10 8.82176L7.64333 6.46509L6.465 7.64342L8.82166 10.0001L6.465 12.3568L7.64333 13.5351Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 18.3334C14.595 18.3334 18.3333 14.5951 18.3333 10.0001C18.3333 5.40508 14.595 1.66675 9.99999 1.66675C5.40499 1.66675 1.66666 5.40508 1.66666 10.0001C1.66666 14.5951 5.40499 18.3334 9.99999 18.3334ZM9.99999 3.33341C13.6758 3.33341 16.6667 6.32425 16.6667 10.0001C16.6667 13.6759 13.6758 16.6667 9.99999 16.6667C6.32416 16.6667 3.33332 13.6759 3.33332 10.0001C3.33332 6.32425 6.32416 3.33341 9.99999 3.33341Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5fc966c0f98e37957747dab8955b89b0.svg";
export { ForwardRef as ReactComponent };